import { TEAM_NAMES } from './teams';
import { getPlayerImageWithOverrides, PLAYER_IMAGE_OVERRIDES } from './playerImageFix';

const ESPN_TEAM_SLUG: Record<string, string> = {
  WAS: 'wsh',
  JAX: 'jax',
  WSH: 'wsh',
};

export const PLAYER_PLACEHOLDER = '/images/player-placeholder.png';

export function teamLogoUrl(teamAbbrev?: string): string {
  if (!teamAbbrev) return '/images/defense-placeholder.png';
  const key = teamAbbrev.toUpperCase();
  if (!(key in TEAM_NAMES) && key !== 'WSH') {
    return '/images/defense-placeholder.png';
  }
  const slug = ESPN_TEAM_SLUG[key] || key.toLowerCase();
  return `https://a.espncdn.com/i/teamlogos/nfl/500/${slug}.png`;
}

export function sleeperHeadshotUrl(sleeperId?: string | number): string | undefined {
  if (sleeperId === undefined || sleeperId === null || sleeperId === '') return undefined;
  return `https://sleepercdn.com/content/nfl/players/thumb/${sleeperId}.jpg`;
}

export function espnHeadshotUrl(espnId?: string | number): string | undefined {
  if (espnId === undefined || espnId === null || espnId === '') return undefined;
  return `https://a.espncdn.com/i/headshots/nfl/players/full/${espnId}.png`;
}

export function playerImageCandidates(
  name: string | undefined,
  position: string | undefined,
  team: string | undefined,
  espnId?: string | number,
  sleeperId?: string | number
): string[] {
  if (position === 'DEF') {
    return [teamLogoUrl(team)];
  }

  const urls: string[] = [];
  const override = name ? PLAYER_IMAGE_OVERRIDES[name.toLowerCase()] : undefined;
  if (override) urls.push(override);

  const sleeper = sleeperHeadshotUrl(sleeperId);
  if (sleeper) urls.push(sleeper);

  const espn = espnHeadshotUrl(espnId);
  if (espn && !urls.includes(espn)) urls.push(espn);

  const legacy = getPlayerImageWithOverrides(
    name,
    espnId !== undefined && espnId !== null ? String(espnId) : undefined,
    PLAYER_PLACEHOLDER
  );
  if (legacy && !urls.includes(legacy) && legacy !== PLAYER_PLACEHOLDER) {
    urls.push(legacy);
  }

  urls.push(PLAYER_PLACEHOLDER);
  return urls;
}

export function playerImageUrl(
  name: string | undefined,
  position: string | undefined,
  team: string | undefined,
  espnId?: string | number,
  sleeperId?: string | number
): string {
  return playerImageCandidates(name, position, team, espnId, sleeperId)[0];
}
